// カレントの取得
const headerNavLink = document.querySelectorAll('.l-sub-nav__item__link');

headerNavLink.forEach((targetLink) => {
  if (targetLink.href === location.href) {
    targetLink.parentElement.classList.add('is-current');
  }
});
